import React from 'react';

interface ShiftManagementSkeletonProps {
  shiftCount?: number;
  className?: string;
}

export const ShiftManagementSkeleton: React.FC<ShiftManagementSkeletonProps> = ({
  shiftCount = 2,
  className = '',
}) => {
  return (
    <div className={`space-y-6 ${className}`}>
      {/* Header skeleton */}
      <div className="animate-pulse">
        <div className="h-6 bg-gray-200 rounded w-48 mb-2"></div>
        <div className="h-4 bg-gray-200 rounded w-72"></div>
      </div>

      {/* Form skeleton */}
      <div className="bg-white rounded-lg border border-gray-200 p-6 animate-pulse">
        <div className="space-y-4">
          {/* Form title */}
          <div className="h-5 bg-gray-200 rounded w-32"></div>
          
          {/* Form fields row 1 */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div className="space-y-2">
              <div className="h-4 bg-gray-200 rounded w-20"></div>
              <div className="h-10 bg-gray-100 rounded border"></div>
            </div>
            <div className="space-y-2">
              <div className="h-4 bg-gray-200 rounded w-24"></div>
              <div className="h-20 bg-gray-100 rounded border"></div>
            </div>
          </div>

          {/* Form fields row 2 */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div className="space-y-2">
              <div className="h-4 bg-gray-200 rounded w-20"></div>
              <div className="h-10 bg-gray-100 rounded border"></div>
            </div>
            <div className="space-y-2">
              <div className="h-4 bg-gray-200 rounded w-20"></div>
              <div className="h-10 bg-gray-100 rounded border"></div>
            </div>
          </div>

          {/* Advanced toggle */}
          <div className="flex items-center space-x-2">
            <div className="h-4 w-4 bg-gray-200 rounded"></div>
            <div className="h-4 bg-gray-200 rounded w-40"></div>
          </div>

          {/* Action buttons */}
          <div className="flex justify-end space-x-3">
            <div className="h-9 bg-gray-200 rounded w-20"></div>
            <div className="h-9 bg-gray-200 rounded w-24"></div>
          </div>
        </div>
      </div>

      {/* Shifts list skeleton */}
      <div className="bg-white rounded-lg border border-gray-200 p-6 animate-pulse">
        <div className="space-y-4">
          {/* List header */}
          <div className="h-5 bg-gray-200 rounded w-40 mb-4"></div>
          
          {/* Shift cards */}
          <div className="space-y-3">
            {Array.from({ length: shiftCount }).map((_, index) => (
              <div
                key={index}
                className="border border-gray-200 rounded-lg p-4 space-y-3"
              >
                <div className="flex justify-between items-start">
                  <div className="space-y-2 flex-1">
                    {/* Shift name */}
                    <div className="h-5 bg-gray-200 rounded w-32"></div>
                    {/* Shift times */}
                    <div className="h-4 bg-gray-200 rounded w-48"></div>
                    {/* Description */}
                    <div className="h-4 bg-gray-200 rounded w-64"></div>
                  </div>
                  
                  {/* Action buttons */}
                  <div className="flex space-x-2">
                    <div className="h-8 w-8 bg-gray-200 rounded"></div>
                    <div className="h-8 w-8 bg-gray-200 rounded"></div>
                  </div>
                </div>
                
                {/* Status badge */}
                <div className="flex justify-between items-center">
                  <div className="h-6 bg-gray-200 rounded-full w-16"></div>
                  <div className="h-4 bg-gray-200 rounded w-20"></div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};
